export const Size = {
  Large: "LARGE",
  Medium: "MEDIUM",
  Small: "SMALL",
  XLarge: "XLARGE",
};
